import { render } from "./App.vue?vue&type=template&id=c366b35e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c366b35e&lang=css"

import exportComponent from "/Users/macbookpro/Desktop/thecustomer/st-daara/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__